/**
 * DVS Ekim-Kasim hediye kampanyasi
 * Sepette hediye kolye disinda bir urun varsa hediye kolyeyi otomatik ekler,
 * sepette baska urun kalmadiysa cikarir. Fiyati 0 TL yapan sey Shopify'daki
 * otomatik "Buy X Get Y" indirimidir; bu dosya yalnizca urunu sepete koyar.
 */
const cfg = window.DVS_GIFT;
const DECLINED_KEY = 'dvsGiftDeclined';
const HAD_KEY = 'dvsGiftHad';

let busy = false;
let events = null;

function store(method, key, value) {
  try {
    if (method === 'get') return sessionStorage.getItem(key);
    if (method === 'set') sessionStorage.setItem(key, value);
    if (method === 'del') sessionStorage.removeItem(key);
  } catch (e) {
    /* storage kapali olabilir */
  }
  return null;
}

async function getCart() {
  const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  return res.json();
}

async function postJson(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(body),
  });
  return res.json();
}

async function loadEvents() {
  if (events) return events;
  try {
    events = await import('@shopify/events');
  } catch (e) {
    events = null;
  }
  return events;
}

/** Tema bilesenlerinin sepeti yeniden cizmesi ve ust bardaki sayinin guncellenmesi icin olay yayinlar. */
async function announce(action, line) {
  const ev = await loadEvents();
  if (!ev || !ev.CartLinesUpdateEvent) {
    if (location.pathname.indexOf('/cart') === 0) location.reload();
    return;
  }
  try {
    const cart = await getCart();
    const deferred = ev.CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new ev.CartLinesUpdateEvent({
        action,
        context: 'cart',
        lines: [{ id: line.key || '', quantity: line.quantity }],
        promise: deferred.promise,
      })
    );
    deferred.resolve({
      cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, itemCount: cart.item_count, source: 'dvs-gift', didError: false },
    });
  } catch (e) {
    if (location.pathname.indexOf('/cart') === 0) location.reload();
  }
}

async function sync() {
  if (busy) return;
  busy = true;
  try {
    if (Date.now() > cfg.endsAt) return;

    const cart = await getCart();
    const gift = cart.items.find((i) => i.handle === cfg.handle);
    const others = cart.items.filter((i) => i.handle !== cfg.handle);

    if (!others.length) {
      store('del', DECLINED_KEY);
      store('del', HAD_KEY);
      if (gift) {
        await postJson('/cart/change.js', { id: gift.key, quantity: 0 });
        await announce('remove', { key: gift.key, quantity: 0 });
      }
      return;
    }

    if (gift) {
      store('set', HAD_KEY, '1');
      if (gift.quantity > 1) {
        await postJson('/cart/change.js', { id: gift.key, quantity: 1 });
        await announce('update', { key: gift.key, quantity: 1 });
      }
      return;
    }

    // Hediye daha once vardi ve musteri sepetten cikardiysa tekrar ekleme.
    if (store('get', HAD_KEY)) {
      store('set', DECLINED_KEY, '1');
      return;
    }
    if (store('get', DECLINED_KEY)) return;

    const added = await postJson('/cart/add.js', {
      items: [{ id: cfg.variantId, quantity: 1, properties: { _kampanya: 'ekim-kasim-hediye' } }],
    });
    if (added && added.items && added.items.length) {
      store('set', HAD_KEY, '1');
      await announce('add', { key: added.items[0].key, quantity: 1 });
    }
  } catch (e) {
    console.warn('[dvs-gift]', e);
  } finally {
    busy = false;
  }
}

async function init() {
  const ev = await loadEvents();
  if (ev && ev.StandardEvents && ev.StandardEvents.cartLinesUpdate) {
    document.addEventListener(ev.StandardEvents.cartLinesUpdate, (event) => {
      if (busy) return;
      if (event.promise && event.promise.then) {
        event.promise.then(() => setTimeout(sync, 150)).catch(() => {});
      } else {
        setTimeout(sync, 400);
      }
    });
  }
  sync();
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) sync();
  });
}

if (cfg && Date.now() < cfg.endsAt) init();
